import React from 'react'
import { Button, Col, FormGroup, Label,ModalBody,Row } from 'reactstrap';
import { SearchAsync } from '../elements/SearchAsync';
import FormatNumbers from '../../utils/formatNumbers';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const ModalAddExtraPatient = (props) => {

    const {
        searchPatientExtra, searchPatientValue, modalExtraPatients, toggleModalExtraPatients, modalTitle, handleChangeExtraPatient, listTempExtraPatients, handleAddExtraPatients,
        loadingExtraPatients
    } = props;

      
    const headerStyle = 
    {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "10px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = 
    {
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    return (
        
        <Dialog 
            visible={modalExtraPatients}
            modal
            onHide={() => toggleModalExtraPatients("EXTRA_PATIENT")}
            style={{ width: '80vw', maxWidth: '900px', borderRadius: '16px' }}
            headerStyle={{
                background: 'linear-gradient( #0d3b59)',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '12px 12px 0 0'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            header={modalTitle}
            className='pt-0 custom-dialog-addd'
            footer={
                <div>
                    <Button outline color="primary" type="button" onClick={handleAddExtraPatients} size="sm" disabled={loadingExtraPatients} className={loadingExtraPatients ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                        Agregar pacientes
                    </Button>
                </div>
            }
        >
            <ModalBody>
                <Row>
                    <Col sm="12" md="12" lg="12">
                        <FormGroup>
                            <Label className='labelConcept'>Búsqueda por nombre o por nim</Label>
                            <SearchAsync
                                cacheOptions={false}
                                name="searchPatientExtra"
                                value={searchPatientValue}
                                method={handleChangeExtraPatient}
                                loincState={searchPatientExtra}
                                url="Invoice/GetFilterWorkOrders"
                                maxLenght={3}
                                placeholder="Búsqueda por nombre o nim"
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row> 
                    <Col sm="12" md="12" lg="12">
                    <DataTable
                        className="data-table p-datatable-striped p-datatable-sm"
                        value={listTempExtraPatients} 
						paginator
						rows={5}
						emptyMessage={
							<div className="text-center">
								<img
									src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
									style={{ width: "25%" }}
									alt="Sin Muestras"
								/>
								<br />
								<p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
								No hay un registro
								</p>
							</div>
						}
						rowsPerPageOptions={[5,10,15,20]}
						stripedRows
						responsiveLayout="scroll"
                    >
                    <Column
                        body={(rowData, { rowIndex }) => rowIndex + 1}
                        header="#"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                        sortable
                        field='id_work_order'
                    />
                    <Column
                        body={(rowData, { rowIndex }) => (
                            <b className='txt-secondary'>{rowData.nim + " " + rowData.name_patient}</b>
                        )}
                        header="Paciente"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                        sortable
                        field='nim'
                    />
                    <Column
                        body={(rowData) => rowData.name ?? "-----"}
                        header="Estudios"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                        sortable
                        field='name'
                    />
                    <Column
                        body={(rowData) => `$ ${FormatNumbers(rowData?.price ?? 0, 2)}`}
                        header="Precio"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                    />
                    <Column
                        body={(rowData) => `$ ${FormatNumbers(rowData?.price_tax ?? 0, 2)}`}
                        header="Impuesto"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                    />
                    <Column
                        body={(rowData) => `$ ${FormatNumbers(rowData?.total ?? 0, 2)}`}
                        header="Total"
                        headerStyle={{ ...headerStyle, textAlign: "center" }}
                        style={{ ...cellStyle, textAlign: "center" }}
                    />
                    </DataTable>
                    </Col>
                </Row>
            </ModalBody>
           
        </Dialog>    
    )
}
